import { __decorate, __metadata } from "tslib";
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
import CurrentUserMixin, { logout } from '~/nasa_ui/mixins/CurrentUserMixin';
import { NOTIFICATION_TOASTER_NAME } from '~/nasa_ui/modules/Notification';
import { popStoredAuthRedirect } from '~/nasa_ui/utils/authRedirect';
let TheCosmicApplication = class TheCosmicApplication extends Mixins(BaseVue, CurrentUserMixin) {
    NOTIFICATION_TOASTER_NAME = NOTIFICATION_TOASTER_NAME;
    hasApplicationSpecificCreateMenuItems;
    routeConfigs;
    showMyApprovalQueueLink;
    created() {
        const authRedirect = popStoredAuthRedirect();
        if (authRedirect) {
            this.$router.replace(authRedirect);
        }
    }
    logoutUser() {
        logout();
    }
    emitShowApplicationChangeLog() { }
};
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], TheCosmicApplication.prototype, "hasApplicationSpecificCreateMenuItems", void 0);
__decorate([
    Prop({
        type: Array,
        required: false,
        default: () => []
    }),
    __metadata("design:type", Array)
], TheCosmicApplication.prototype, "routeConfigs", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], TheCosmicApplication.prototype, "showMyApprovalQueueLink", void 0);
__decorate([
    Emit('show_application_change_log'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TheCosmicApplication.prototype, "emitShowApplicationChangeLog", null);
TheCosmicApplication = __decorate([
    Component
], TheCosmicApplication);
export default TheCosmicApplication;
